<p class="class__value">
  <ng-container *ngIf="!avis_obj?.avis">En attente
    <ng-container *ngIf="avis_obj?.sollicite?.display_name"> de l'avis de {{avis_obj?.sollicite?.display_name}}</ng-container>
  </ng-container>
  <ng-container *ngIf="avis_obj?.avis">
    Avis de {{avis_obj?.sollicite?.display_name}} : {{avis_obj?.avis}}
  </ng-container>
</p>
<ng-container *ngIf="avis_obj?.avis_observation">
  <p class="class__value">
    Observations :
  </p>
  <p class="avis-observations" [innerHtml]="avis_obj?.avis_observation | newline "></p>
</ng-container>
